// @flow
export default class Enum<T> {
  static isLocked: boolean;
  value: T;

  constructor(value: T) {
    if (this.constructor.isLocked) {
      throw new Error(
        `You attempted to add a property to an Enum after it was locked: ${String(value)}`
      );
    }

    if (typeof value === 'undefined') {
      throw new Error('Cannot define an Enum type with no value');
    }

    this.value = value;
  }

  toString(): string {
    return String(this.value);
  }

  static fromValue(value: ?T): ?this {
    if (value === undefined) return undefined;
    let found;

    Object.keys(this).forEach((key: string) => {
      if (this[key].value === value) {
        found = this[key];
      }
    });

    return found;
  }

  static get values(): Array<Enum<T>> {
    return Object.keys(this).reduce(
      (acc: Array<Enum<T>>, key: string) => (this[key] instanceof this ? [...acc, this[key]] : acc),
      []
    );
  }
}



// WEBPACK FOOTER //
// ../react-lib/src/types/Enum.js